import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'
import {InputText} from '../input-text/InputText'
import {Dialog, Popover} from '@ariakit/react'

export const StyledPopover = styled(Popover)(
    ({theme: {palette, shadows, zIndex}}) => css`
        z-index: ${zIndex.dropdown};
        background-color: ${palette.neutral.white};
        border-radius: 12px;
        box-shadow: ${shadows.md};
    `
)

export const StyledDialog = styled(Dialog)(
    ({theme: {palette, shadows, zIndex}}) => css`
        z-index: ${zIndex.dropdown};
        background-color: ${palette.neutral.white};
        border-radius: 4px;
        box-shadow: ${shadows.md};
    `
)

export const StyledDialogBackdrop = styled.div(
    ({theme: {palette}}) => css`
        background: ${palette.neutral['600']};
        opacity: 0.6;
    `
)

export const StyledInputDateCalendarButton = styled(Button)<{$hasError: boolean}>(
    ({theme: {palette}, $hasError}) => css`
        border-radius: 8px 0 0 8px;
        outline: 1px solid ${$hasError ? palette.danger['300'] : palette.neutral['300']};
        &:disabled {
            background-color: ${palette.neutral['100']};
            box-shadow: none;
        }
    `
)

export const StyledInputDateText = styled(InputText)<{$hasError: boolean}>(
    ({theme: {palette}, $hasError}) => css`
        border-radius: 0 8px 8px 0;
        & div {
            border-radius: 0 8px 8px 0;
            outline: 1px solid ${$hasError ? palette.danger['300'] : palette.neutral['300']};
        }
    `
)

export const StyledDatePickerWrapper = styled.div(
    ({theme: {palette, spacing}}) => css`
        .rdp-root {
            border-radius: 12px;
            overflow: hidden;
            padding: ${spacing * 3}px;
            background-color: ${palette.neutral.white};
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }
    `
)
